import React, {useEffect, useState} from 'react';
import {FaRandom, FaUserPlus} from 'react-icons/fa';
import {Link, useNavigate, useParams} from 'react-router-dom';
import {alertaDeErro, alertaDeSucesso} from "../services/alertServices";
import {ModalCriarJogador} from "../components/modals/ModalCriarJogador";

export const PrepararJogos = () => {
    const {id} = useParams();
    const [participantesAvulsos, setParticipantesAvulsos] = useState([]);
    const [modalOpen, setModalOpen] = useState(false);

    const [jogadoresCadastrados, setJogadoresCadastrados] = useState([]);
    const [loadingJogadores, setLoadingJogadores] = useState(true);
    const [jogadoresSelecionados, setJogadoresSelecionados] = useState([]);
    const [duplas, setDuplas] = useState([]);
    const [salvandoJogos, setSalvandoJogos] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        const carregarJogadores = async () => {
            try {
                const response = await fetch('/api/Jogadores');
                if (!response.ok) {
                    throw new Error('Erro ao carregar jogadores');
                }
                const data = await response.json();
                setJogadoresCadastrados(data);
            } catch (e) {
                console.error(e);
            } finally {
                setLoadingJogadores(false);
            }
        };

        carregarJogadores();
    }, []);

    const toggleModal = () => {
        setModalOpen(!modalOpen);
    };

    const onJogadorCriado = async (novoJogador) => {
        setJogadoresCadastrados(prev => [...prev, novoJogador]);
    };

    const toggleJogadorSelecionado = (jogadorId) => {
        setJogadoresSelecionados(prev =>
            prev.includes(jogadorId)
                ? prev.filter(id => id !== jogadorId)
                : [...prev, jogadorId]
        );
    };

    const sortearDuplas = async () => {
        const todosParticipantes = [
            ...participantesAvulsos,
            ...jogadoresCadastrados.filter(j => jogadoresSelecionados.includes(j.id))
        ];

        if (todosParticipantes.length < 2) {
            await alertaDeErro('Selecione pelo menos 2 participantes para sortear duplas');
            return;
        }

        const embaralhados = [...todosParticipantes].sort(() => Math.random() - 0.5);
        const novasDuplas = [];

        for (let i = 0; i < embaralhados.length; i += 2) {
            if (i + 1 < embaralhados.length) {
                novasDuplas.push([embaralhados[i], embaralhados[i + 1]]);
            } else {
                novasDuplas.push([embaralhados[i]]);
            }
        }

        setDuplas(novasDuplas);
    };

    const criarJogos = async () => {
        try {
            setSalvandoJogos(true);

            const duplasCompletas = duplas.filter(d => d.length === 2);
            const jogosParaCriar = [];

            for (let i = 0; i < duplasCompletas.length; i += 2) {
                if (i + 1 < duplasCompletas.length) {
                    const duplaA = duplasCompletas[i];
                    const duplaB = duplasCompletas[i + 1];

                    jogosParaCriar.push({
                        idJogadorA1: duplaA[0].id,
                        idJogadorA2: duplaA[1].id,
                        idJogadorB1: duplaB[0].id,
                        idJogadorB2: duplaB[1].id
                    });
                }
            }

            await Promise.all(
                jogosParaCriar.map(jogo =>
                    fetch('/api/Jogos', {
                        method: 'POST',
                        headers: {'Content-Type': 'application/json'},
                        body: JSON.stringify(jogo)
                    })
                )
            );

            await alertaDeSucesso('Jogos do dia criados com sucesso!');

            navigate(`/jogos-do-dia/${id}`);
        } catch (e) {
            console.error(e);
            await alertaDeErro('Erro ao criar os jogos no servidor.');
        } finally {
            setSalvandoJogos(false);
        }
    };

    return (
        <>
            <div className="container">
                <div className="card bg-info-subtle shadow-sm mb-3">
                    <div className="card-body">
                        <h5 className="card-title">Selecionar participantes</h5>
                        <p className="text-muted">
                            {jogadoresSelecionados.length + participantesAvulsos.length} participante(s) selecionado(s)
                        </p>
                        <button className="btn btn-primary me-2 w-100" onClick={toggleModal}>
                            <FaUserPlus className="me-2"/>
                            Adicionar Novo Jogador
                        </button>
                    </div>
                </div>

                {loadingJogadores ? (
                    <p>Carregando jogadores cadastrados...</p>
                ) : (
                    <div className="row">
                        {jogadoresCadastrados.map(jogador => (
                            <div key={jogador.id} className="col-md-4 col-sm-6 mb-3">
                                <div
                                    className={`card shadow-sm h-100 ${
                                        jogadoresSelecionados.includes(jogador.id)
                                            ? 'border-primary bg-primary bg-opacity-10'
                                            : ''
                                    }`}
                                    onClick={() => toggleJogadorSelecionado(jogador.id)}
                                    style={{cursor: 'pointer', transition: 'all 0.3s ease'}}
                                >
                                    <div className="card-body d-flex align-items-center justify-content-between">
                                        <div className="flex-grow-1">
                                            <h6 className="mb-0 fw-bold">{jogador.nome}</h6>
                                        </div>
                                        <div>
                                            {jogadoresSelecionados.includes(jogador.id) ? (
                                                <div
                                                    className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center"
                                                    style={{width: '30px', height: '30px'}}>
                                                    ✓
                                                </div>
                                            ) : (
                                                <div className="border border-secondary rounded-circle"
                                                     style={{width: '30px', height: '30px'}}>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}

                <button
                    className="btn btn-success mb-2 w-100"
                    onClick={sortearDuplas}
                    disabled={jogadoresSelecionados.length + participantesAvulsos.length < 2}
                >
                    <FaRandom className="me-2"/>
                    Sortear duplas
                </button>

                {duplas.map((dupla, index) => (
                    <div key={index} className="card bg-info-subtle mb-2">
                        <div className="card-body">
                            <strong>Dupla {index + 1}:</strong>{' '}
                            {dupla[0].nome}
                            {dupla[1] && (
                                <>
                                    {' & '}
                                    {dupla[1].nome}
                                </>
                            )}
                            {!dupla[1] && ' (Jogador sem dupla)'}
                        </div>
                    </div>
                ))}

                {duplas.length > 0 && (
                    <button
                        className="btn btn-success mb-2 w-100"
                        onClick={criarJogos}
                        disabled={jogadoresSelecionados.length + participantesAvulsos.length < 2 || salvandoJogos}
                    >
                        {salvandoJogos ? 'Salvando jogos...' : 'Criar jogos'}
                    </button>
                )}

                {duplas.length === 0 && (
                    <Link
                        to={id ? `/jogos-do-dia/${id}` : '/jogos-do-dia'}
                        className="btn btn-primary mb-2 w-100">
                        Criar jogos manualmente
                    </Link>
                )}
            </div>

            <ModalCriarJogador
                isOpen={modalOpen}
                toggle={toggleModal}
                onJogadorCriado={onJogadorCriado}
            />
        </>
    );
};